import _get from 'lodash/get';

let context = {};

export const get = () => context;

export const set = (ctx: any) => {
  context = { ...context, ...ctx };
};

export const setKey = (key: any, value: any) => {
  context[key] = value;
};

export const getKey = (key: any) => {
  if (key in context) {
    return context[key];
  }

  if (typeof window !== 'undefined') {
    return window[key];
  }

  return context[key];
};

export const getPath = (path: any) => {
  let source = context;

  if (typeof window !== 'undefined') {
    source = window;
  }
  return _get(source, path);
};
